import _objectSpread from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { createContext, useRef } from 'react';
import { Provider as RematchProvider } from 'react-redux';
import { CustomsPerformanceMetricsName, useHistoryInitialize } from '@features/libs';
import Modal from '@m4b-design/modal';
import { useHistory } from '@jupiter/plugin-runtime/router';
import { ecLocalStorage, Tea } from '@ecom-alliance/libs';
import { ConnectionQuotaContextProvider } from '@business/seller';
import { GrayscaleHitKeyEnum } from '@business/seller/src/constants';
import { setBuildInfo } from '@/adapter/libs';
import { store } from '@/store';
import ConnectionStateProvider from '@/hooks/use-connection-state';
import 'tailwindcss/tailwind.css';
import './App.css';
import '@byted/commerce-materials/dist/css/index.css';
import Entry from './Entry';
import { affiliateInvitationApiClient } from './api/affiliate/serv/oec_affiliate_invitation_api';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var AppRuntimeContext = /*#__PURE__*/createContext({});
performance.mark(CustomsPerformanceMetricsName.LoadSubAppEnd);
setBuildInfo === null || setBuildInfo === void 0 ? void 0 : setBuildInfo(buildInfo);
var App = function App(props) {
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    contextModal = _Modal$useModal2[0],
    contextHolder = _Modal$useModal2[1];
  var history = useHistory();
  var modalRef = useRef({
    contextModal: contextModal,
    contextHolder: contextHolder
  });
  var account = props.account,
    grayscaleHitStatus = props.grayscaleHitStatus,
    isLoadingGrayscaleStatus = props.isLoadingGrayscaleStatus,
    platformConfig = props.platformConfig;
  useHistoryInitialize({
    history: history,
    region: (account === null || account === void 0 ? void 0 : account.region) || ''
  });
  return /*#__PURE__*/_jsx(RematchProvider, {
    store: store,
    children: /*#__PURE__*/_jsx(AppRuntimeContext.Provider, {
      value: _objectSpread(_objectSpread({}, props), {}, {
        contextModal: modalRef.current.contextModal
      }),
      children: /*#__PURE__*/_jsx(ConnectionQuotaContextProvider, {
        isHitGrayScale: grayscaleHitStatus === null || grayscaleHitStatus === void 0 ? void 0 : grayscaleHitStatus[GrayscaleHitKeyEnum.CONNECTION_QUOTA_GRAYSCALE],
        hasFlatFee: grayscaleHitStatus === null || grayscaleHitStatus === void 0 ? void 0 : grayscaleHitStatus[GrayscaleHitKeyEnum.FLAT_FEE_GRAYSCALE],
        isLoadingGrayscaleStatus: isLoadingGrayscaleStatus,
        account: account,
        ecLocalStorage: ecLocalStorage,
        platformConfig: platformConfig,
        sendTeaLog: Tea.sendTeaLog,
        fetchQuotaData: function fetchQuotaData() {
          return affiliateInvitationApiClient.AffiliateSellerQuotaInfo({});
        },
        checkCreatorConnection: function checkCreatorConnection(_creatorIdList) {
          return affiliateInvitationApiClient.AffiliateSellerCreatorConnectCheck({
            creator_ids: _creatorIdList
          });
        },
        children: /*#__PURE__*/_jsxs(ConnectionStateProvider, {
          children: [modalRef.current.contextHolder, /*#__PURE__*/_jsx(Entry, {})]
        })
      })
    })
  });
};
export default App;